module.exports = __webpack_public_path__ + "img/logo.6ca73f29.png";